import React from 'react'
import './Portfolio.css'
import{Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/css'

import Amazon from '/Users/kritikpatni/portfolio-website/src/Assets/ME_ME_PROJECT_AMAZON_CLONE_REACT_MODULE_ME_PROJECT_AMAZON_CLONE_REACT_MODULE_AMAZON_CLONE_REACT_9_sample_app_screenshot.png';
import Spotify from '/Users/kritikpatni/portfolio-website/src/Assets/login-page.png'
import Music from '/Users/kritikpatni/portfolio-website/src/Assets/musicapp.png'
import {useContext} from "react"
import {themeContext, ThemeProvider} from '/Users/kritikpatni/portfolio-website/src/Context.js'
function Portfolio() {


  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  
  return (
    <div className='portfolio' id='Portfolio'>
        <span style={{color: darkMode?'white': ''}}>Recent Projects</span>
        <span>Portfolio</span>
      
        <Swiper 
        
        spaceBetween={30}
        slidesPerView={3}
        grabCursor={true}
        className="portfolio-slider"
      >
        <SwiperSlide>
          <img src={Amazon} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Spotify} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Music} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Music} alt="" />
        </SwiperSlide>

        
      </Swiper>
    </div>


  )
}

export default Portfolio
